module.exports = __webpack_public_path__ + "img/mclean.f0f8f9b1.jpg";